import React, { Component } from 'react';
import { post, get } from '../custom_libraries/serverRequests';
import globalVariables from '../custom_libraries/globalVariables';
import { Link } from 'react-router-dom';
import './adminDash.css';
import urls from '../custom_libraries/urls';
import BackArrow from '../assets/icons8-back-arrow.gif';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';
import Backdrop from '@mui/material/Backdrop';
// import CircularProgress from '@mui/material/CircularProgress';
import withNavigate from '../Global_files/WithNavigate';
import WebLogo from '../assets/Artboard 1Bonus.png';
import passwordEye from '../assets/icons8-eye-64.png';

//-------------dark theme-------------------------------------
import { createTheme, ThemeProvider } from "@mui/material/styles"; //MUI dark theme using ThemeProvider
import CssBaseline from "@mui/material/CssBaseline";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      // default: "#000000",
      // paper: "#121212",
      default: "#191e29",
      paper: "#212632",
    },
    text: {
      primary: "#ffffff",
      secondary: "#bbbbbb",
    },
  },
});
//------------------------------------------

class DealerRegistration extends Component {

    constructor(props) {
        super(props);
        this.state = {
        user_type: 'DealerUser',
        // user_name: '',
        dealer_email:'',
        // dealer_password:'',
        // conf_dealer_pass:'',
        comment:'',
        company_name: '',
        businessType: '',
        first_name:'',
        last_name:'',
        mob_num:'',
        usingAI:'',
        warning: false,
        warning1: false,
        warning2: false,
        warning3: false,
        warning4: false,
        success: false,
        error:false,
        open_progress_bar: false,
        passwordShown:false,
        confPasswordShown:false

        };
      }

      componentDidUpdate(prevProps, prevState) {
        if (
            this.state.warning !== prevState.warning ||
            this.state.error !== prevState.error ||
            this.state.warning2 !== prevState.warning2 ||
            this.state.warning1 !== prevState.warning1 ||
            this.state.warning3 !== prevState.warning3 ||
            this.state.warning4 !== prevState.warning4 ||
            this.state.success !== prevState.success
        ) {
            if (
                this.state.warning ||
                this.state.error ||
                this.state.warning1 ||
                this.state.warning2 ||
                this.state.warning3 ||
                this.state.warning4 ||
                this.state.success
            ) {
                setTimeout(() => {
                    this.setState({
                        warning: false,
                        error: false,
                        warning1: false,
                        warning2: false,
                        warning3: false,
                        warning4: false,
                        success: false,
                    });
                }, 4000); // 1 second
            }
        }
    }



jsonData = () => {

    if (
      !this.state.first_name ||
      !this.state.last_name ||
      !this.state.company_name ||
      !this.state.businessType ||
      !this.state.usingAI ||
      !this.state.comment
    ) {
      this.stopLoading();
      this.setState({ warning: true });
      return;
    }

    // First check empty fields
    if (!this.state.mob_num || this.state.mob_num.trim() === "") {
      this.stopLoading();
      alert("Mobile number is required");
      return;
    }

    // mob no validation
    if (this.state.mob_num.length !== 10) {
      this.stopLoading();
      alert("Mobile number must be exactly 10 digits");
      return; // Prevent form submission
    }

    // First check empty fields
    if (!this.state.dealer_email || this.state.dealer_email.trim() === "" ) {
      this.stopLoading();
      alert("Email address is required");
      return;
    }

    // Email format validation
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(this.state.dealer_email))
      {
        this.stopLoading();
        alert("Please enter a valid email address");
        return;
      }

    let data = {

      // "user_type":"DealerUser",
      "comment": this.state.comment,
      "email": `${this.state.dealer_email}`,
      "company_name": this.state.company_name,
      "business_type": this.state.businessType,
      "ai_usage": this.state.usingAI,
      "first_name": this.state.first_name,
      "last_name": this.state.last_name,
      "phone_number": this.state.mob_num,
      // "admin_email":this.state.dealer_email,

    }
    return JSON.stringify(data)
  }


  // InsertDealerRegistrationInfo = async () => {
  //   this.startLoading();

  //   let headers = {
  //       'content-type': 'application/json'
  //   };

  //   let post_data = this.jsonData();
  //   if (!post_data) return;  // stop if validation failed
  //   console.log("post_data in insertCreateTicketInfo:", post_data);

  //   let postDataObj = JSON.parse(post_data);

  //   for (const key in postDataObj) {
  //       if (postDataObj[key] === null || postDataObj[key] === undefined || postDataObj[key] === "") {
  //           this.setState({ warning: true });
  //           this.stopLoading();
  //           return;
  //       }
  //   }

  //   try {
  //       let response = await fetch(urls.REGISTER, {
  //           headers: headers,
  //           method: 'POST',
  //           body: post_data
  //       });

  //       let jsonResponse = await response.json();  //  Parse JSON response
  //       console.log("Response from server:", jsonResponse);

  //       this.stopLoading();
  //       if (jsonResponse.detail?.includes("Verification e-mail sent.")) {
  //           //  Successful registration (new response format)
  //           this.setState({ success: true });

  //           console.log("User registered successfully. API Key:", jsonResponse.detail);

  //           //  Store the API key if needed
  //           // localStorage.setItem("auth_token", jsonResponse.key);

  //           //  Redirect user after success
  //           setTimeout(() => {
  //               this.props.navigate("/");
  //           }, 2000);
  //           return;
  //       }

  //       //  NORMALIZE ALL ERRORS INTO AN ARRAY OF STRINGS
  //     let errors = [];

  //     if (Array.isArray(jsonResponse)) {
  //       // Direct array like ["Wrong Admin Passcode."]----
  //       errors = jsonResponse;
  //     } else if (typeof jsonResponse === "object" && jsonResponse !== null) {
  //       Object.entries(jsonResponse).forEach(([field, value]) => {
  //         if (Array.isArray(value)) {
  //           value.forEach(v => {
  //             if (typeof v === "string") {
  //               errors.push(v);
  //             } else if (v?.message) {
  //               errors.push(v.message);
  //             }
  //           });
  //         } else if (typeof value === "string") { //safe side check
  //           errors.push(value);
  //         }
  //       });
  //     }

  //     console.log("Normalized errors:", errors);

  //     // MATCH ERRORS TO WARNINGS
  //     errors.forEach(err => {
  //       if (err.includes("username already exists")) {
  //         this.setState({ warning1: true });
  //       } else if (err.includes("password is too short")) {
  //         this.setState({ warning2: true });
  //       } else if (err.includes("didn't match")) {
  //         this.setState({ warning3: true });
  //       } else if (err.includes("User with this Email address already exists.")) {
  //         this.setState({ warning4: true });
  //       } else {
  //         this.setState({ error: true }); // fallback
  //       }
  //     });

  //   } catch (error) {
  //       console.error("Error in Admin/Dealer Registration:", error);
  //       this.stopLoading();
  //       this.setState({ error: true });
  //       return;
  //   }
  // };

  InsertBookDemoInfo = async () => {
        this.startLoading();

    let headers = {
        'content-type': 'application/json'
    };

    let post_data = this.jsonData();
    if (!post_data) return;  // stop if validation failed

    let postDataObj = JSON.parse(post_data);

    for (const key in postDataObj) {
        if (postDataObj[key] === null || postDataObj[key] === undefined || postDataObj[key] === "") {
            this.setState({ warning: true });
            this.stopLoading();
            return;
        }
    }

    try {
        let response = await fetch(urls.BOOK_DEMO, {
            headers: headers,
            method: 'POST',
            body: post_data
        });

        let jsonResponse = await response.json();  //  Parse JSON response
        this.stopLoading();
        if (jsonResponse.data && jsonResponse.message?.includes("Form submitted successfully")) {
            //  Successful registration (new response format)
            this.setState({ success: true });
            //  Redirect user after success
            setTimeout(() => {
                this.props.navigate("/");
            }, 2000);
            return;
        }

    } catch (error) {
        console.error("Error in submitting the form", error);
        this.stopLoading();
        this.setState({ error: true });
        return;
    }
  }

  startLoading = () => {
    console.log("startloading")
    this.setState({ open_progress_bar: true });
  }

  stopLoading = () => {
      this.setState({ open_progress_bar: false });
  }

  togglePasswordVisiblity = () => {
    this.setState(prevState => ({
      passwordShown: !prevState.passwordShown
    }));
    };

  toggleConfirmPasswordVisiblity = () => {
    this.setState(prevState => ({
      confPasswordShown: !prevState.confPasswordShown
    }));
    };

  handleChange = (event) => {
    this.setState({usingAI: event.target.value});
  };

  render(){
    const {warning, warning1, warning2, warning3, warning4, success, error, passwordShown, confPasswordShown} = this.state;
      return (
        <ThemeProvider theme={darkTheme}>
                <CssBaseline />
        <div>
            <div style={{ display: 'flex', backgroundColor: '#003366', color:"white", padding:'8px',  }}>
            <Link to="/" style={{color:'#fff', textDecoration: 'none', fontSize:'18px'}}><img src={BackArrow} alt="Back arrow" style={{ marginRight: '8px', borderRadius:'35px', width:'30px' }} /></Link>
              {/* <em>Register New Admin/Dealer User</em>&emsp; &gt;&gt; */}
              <em>Book a demo with an EyeOn8i representative and learn how we can help to make your organization safer using AI.</em>&emsp; &gt;&gt;
            </div>

                <div className="bordered-div-book-demo" >
                  <div>
                          {warning ? (
                                <Alert severity="warning" style={{ marginLeft:'7%', width: "480px" }}>Please fill all the required fields!</Alert>
                            // ) : warning1 ? (
                            //   <Alert severity="warning" style={{ marginLeft:'7%', width: "480px" }}>User name or email already exist!</Alert>
                            // ) : warning2 ? (
                            //   <Alert severity="warning" style={{ marginLeft:'7%', width: "480px" }}>Password is too short! enter minimum 8 characters.</Alert>
                            // ) : warning3 ? (
                            //  <Alert severity="warning" style={{ marginLeft:'7%', width: "480px" }}>The two password fields didn't match!</Alert>
                            // )  : warning4 ? (
                            //  <Alert severity="warning" style={{ marginLeft:'7%', width: "480px" }}>The User with this Email address already exists!</Alert>
                            ) : error ? (
                                <Alert severity="error" style={{ marginLeft:'7%', width: "480px" }}>Server Error! Your request has not processed, try again later!</Alert>
                            ) : success ? (
                                <Alert icon={<CheckIcon fontSize="inherit" />} severity="success" style={{ marginLeft:'7%', width: "480px" }}>
                                    "Great! Your request has been submitted successfully. Our representative will contact you shortly"
                                </Alert>
                            ) : null}
                  </div><br/>

                  <div className='form-group'>
                      <label htmlFor="first_name" > First name <span style={{color:'red'}}>*</span> : &nbsp;</label>
                      <input
                          type="text"
                          id="first_name"
                          name="first_name"
                          required
                          style={{ width: '350px', height: '0.7cm' }}

                          value={this.state.first_name}
                          onChange={(evt) => this.setState({ first_name: evt.target.value })}
                        />
                  </div>
                  <div className='form-group'>
                      <label htmlFor="last_name" > Last name <span style={{color:'red'}}>*</span> : &nbsp;</label>
                      <input
                          type="text"
                          id="last_name"
                          name="last_name"
                          required
                          style={{ width: '350px', height: '0.7cm' }}

                          value={this.state.last_name}
                          onChange={(evt) => this.setState({ last_name: evt.target.value })}
                        />
                  </div>

                  <div className='form-group'>
                      <label htmlFor="dealer_email"> Email <span style={{color:'red'}}>*</span> : &nbsp;</label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          required
                          style={{ width: '350px', height: '0.7cm' }}
                          value={this.state.dealer_email}
                          onChange={(evt) => this.setState({ dealer_email: evt.target.value })}
                        />
                  </div>

                  <div className='form-group'>
                      <label htmlFor="mob_num" > Mobile no. <span style={{color:'red'}}>*</span>  :&nbsp;</label>
                      <div style={{display:'flex', flexDirection:'column'}}>
                      <input
                          type="tel"
                          id="mob_num"
                          name="mob_num"
                          required
                          style={{ width: '350px', height: '0.7cm' }}
                          value={this.state.mob_num}
                          // onChange={(evt) => this.setState({ mob_num: evt.target.value })}
                          onChange={(evt) => {
                            const value = evt.target.value.replace(/\D/g, ""); // Only allow numbers
                            if (value.length <= 10) {
                              this.setState({ mob_num: value });
                            }
                          }}
                        />
                        {this.state.mob_num.length > 0 && this.state.mob_num.length !== 10 && (
                          <p style={{ color: 'red', fontSize:'14px' }}>Mobile number must be exactly 10 digits</p>
                        )}
                        </div>
                  </div>

                  <div className='form-group'>
                      <label htmlFor="company_name" > Company name <span style={{color:'red'}}>*</span> : &nbsp;</label>
                      <input
                          type="text"
                          id="company_name"
                          name="company_name"
                          required
                          style={{ width: '350px', height: '0.7cm' }}

                          value={this.state.company_name}
                          onChange={(evt) => this.setState({ company_name: evt.target.value })}
                        />
                  </div>

                  <div className='form-group' >
                    <label>Are You Using AI Today?<span style={{color:'red'}}>*</span> :</label>

                    <div style={{display: "block", flexDirection:'row', fontSize: "14px", justifyContent: "left", alignItems: "left"}}>
                      <label >
                        <input type="radio" name="using_ai" value="one_vendor" checked={this.state.usingAI === "one_vendor"} onChange={this.handleChange} style={{ marginRight: "5px", width: "16px", height: "16px" }}/>
                        Yes - One primary vendor
                      </label>
                      <label>
                        <input type="radio" name="using_ai" value="multiple_vendors" checked={this.state.usingAI === "multiple_vendors"} onChange={this.handleChange} style={{ marginRight: "5px", width: "16px", height: "16px" }}/>
                        Yes - Multiple vendors
                      </label>
                      <label>
                        <input type="radio" name="using_ai" value="no" checked={this.state.usingAI === "no"} onChange={this.handleChange} style={{ marginRight: "5px", width: "16px", height: "16px" }}/>
                        No - We are not currently using AI
                      </label>
                    </div>
                  </div>

                  <div className='form-group'>
                    <label htmlFor="userType" style={{ display: "block", marginBottom: "8px" }}>
                      Which Option Best Describes Your Business?<span style={{color:'red'}}>*</span> : &nbsp;</label>
                    <select
                      id="userType"
                      name="userType"
                      value={this.state.businessType}
                      onChange={(evt) => this.setState({ businessType: evt.target.value })}
                      style={{
                        width: "25.5%",
                      }}
                    >
                      <option value="" readonly >Please Select</option>
                      <option value="EyeOn8i">EyeOn8i</option>
                      <option value="EyeOn8i_friends_family">EyeOn8i Friends and Family</option>
                      <option value="analyst">Analyst</option>
                      <option value="competitor">Competitor</option>
                      <option value="end_user_commercial">End User - Commercial</option>
                      <option value="end_user_enterprise">End User - Enterprise</option>
                      <option value="end_user_other">End User - Other</option>
                      <option value="end_user_smb">End User - SMB</option>
                      <option value="media">Media</option>
                      <option value="partner_distributor">Partner - Distributor</option>
                      <option value="partner_manufacturers_rep">Partner - Manufacturers Rep</option>
                      <option value="partner_monitoring_software">Partner - Monitoring Software</option>
                      <option value="partner_monitoring_center">Partner - Monitoring Center</option>
                      <option value="partner_oem_private_label">Partner - OEM / Private Label</option>
                      <option value="partner_specifier_ae">Partner - Specifier A&amp;E</option>
                      <option value="partner_systems_integrator">Partner - Systems Integrator</option>
                      <option value="partner_systems_integrator_monitoring_dealer">
                        Partner - Systems Integrator Monitoring Dealer
                      </option>
                      <option value="partner_technology">Partner - Technology</option>
                    </select>
                  </div>

                  <div className='form-group'>
                    <label htmlFor="comment"> Comment <span style={{color:'red'}}>*</span> : &nbsp;</label>

                    <textarea
                      id="comment"
                      name="comment"
                      value={this.state.comment}
                      onChange={(e) => this.setState({comment: e.target.value})}
                      placeholder="Write your comment here..."
                      rows={3}
                      style={{
                        width: "25%",
                        resize: "vertical", // allows height adjustment
                        minHeight: "60px",
                      }}
                    />
                  </div>
                </div>

            <div style={{ width: '135px', height: '0.6cm', marginLeft:'170px', marginTop:'7px', marginBottom: '100px'  }}>
              {/* <Link to="/all_tech_issues"> */}
              <button id='rowsPerPageButton'
                // onClick={this.InsertDealerRegistrationInfo}
                onClick={this.InsertBookDemoInfo}
              >
                Book Demo
              </button>
              {/* Backdrop with CHM logo Progress */}
              <Backdrop open={this.state.open_progress_bar}>
                <div className="custom-spinner">
                  <div className="circle"></div>
                  <div className="circle tilted"></div>
                  <img src={WebLogo} alt="web-logo" style={{backgroundColor:'#001f54', borderRadius:'100px'}}/>
                </div>
              </Backdrop>
              {/* </Link> */}
            </div>
            <div id="copyright-footer">
                <p style={{fontSize:'12px'}}>
                <em>&copy; 2024 Neudeep Technologies. All rights reserved.</em>
                </p>
              </div>
        </div>
        </ThemeProvider>
      )
  }
}


export default withNavigate(DealerRegistration);